"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DaysDialog = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@veeam/core");
const components_1 = require("@veeam/components");
const core_2 = require("../../../core");
const DaysInteractor_1 = require("./DaysInteractor");
const DaysModel_1 = require("./DaysModel");
const types_1 = require("./types");
const DaysDialog = ({ selectedDays, mode = types_1.DAYS_DIALOG_MODE.selection, onDeactivate, onDone, onCancel, onClose, texts, }) => {
    const { t } = core_2.useFeatureContext();
    const { interactor } = core_1.useInteractor(() => {
        const listener = {
            onDeactivate,
            onDone,
            onCancel,
            onClose,
        };
        const model = new DaysModel_1.DaysModel(selectedDays);
        return new DaysInteractor_1.DaysInteractor(model, listener);
    });
    const { value: modelValue } = core_1.useModel(interactor.model);
    const isViewMode = mode === types_1.DAYS_DIALOG_MODE.view;
    const header = isViewMode
        ? (texts === null || texts === void 0 ? void 0 : texts.headerViewMode) || t('daysDialog|headers|viewMode')
        : (texts === null || texts === void 0 ? void 0 : texts.headerSelectionMode) || t('daysDialog|headers|selectionMode');
    return (react_1.default.createElement(components_1.Dialog, { id: "daysDialog", header: header, size: {
            width: components_1.DIALOG_SIZE.xxs,
            height: components_1.DIALOG_SIZE.auto,
        }, onRequestClose: () => {
            interactor.onClose();
        }, actions: isViewMode
            ? [
                {
                    view: components_1.ACTION_VIEW.primary,
                    text: (texts === null || texts === void 0 ? void 0 : texts.buttonViewModeDone) || t('daysDialog|actions|done|viewMode|label'),
                    onClick: () => {
                        interactor.onViewDone();
                    },
                },
            ]
            : [
                {
                    view: components_1.ACTION_VIEW.primary,
                    text: (texts === null || texts === void 0 ? void 0 : texts.buttonSelectionModeDone) ||
                        t('daysDialog|actions|done|selectionMode|label'),
                    disabled: !interactor.isValid(modelValue),
                    onClick: () => {
                        interactor.onSelectionDone();
                    },
                },
                {
                    view: components_1.ACTION_VIEW.secondary,
                    text: (texts === null || texts === void 0 ? void 0 : texts.buttonCancel) || t('daysDialog|actions|cancel|label'),
                    onClick: () => {
                        interactor.onCancel();
                    },
                },
            ] },
        react_1.default.createElement(components_1.FormLayout, { direction: components_1.STACK_DIRECTION.row, disabled: isViewMode },
            react_1.default.createElement(components_1.NoLabelGroup, { content: react_1.default.createElement(components_1.FormLayout, { inlineLabel: true },
                    react_1.default.createElement(components_1.CheckboxField, { label: (texts === null || texts === void 0 ? void 0 : texts.monday) || t('daysDialog|form|fields|monday|label'), field: interactor.form.fields.monday }),
                    react_1.default.createElement(components_1.CheckboxField, { label: (texts === null || texts === void 0 ? void 0 : texts.tuesday) || t('daysDialog|form|fields|tuesday|label'), field: interactor.form.fields.tuesday }),
                    react_1.default.createElement(components_1.CheckboxField, { label: (texts === null || texts === void 0 ? void 0 : texts.wednesday) || t('daysDialog|form|fields|wednesday|label'), field: interactor.form.fields.wednesday }),
                    react_1.default.createElement(components_1.CheckboxField, { label: (texts === null || texts === void 0 ? void 0 : texts.thursday) || t('daysDialog|form|fields|thursday|label'), field: interactor.form.fields.thursday })) }),
            react_1.default.createElement(components_1.NoLabelGroup, { content: react_1.default.createElement(components_1.FormLayout, { inlineLabel: true },
                    react_1.default.createElement(components_1.CheckboxField, { label: (texts === null || texts === void 0 ? void 0 : texts.friday) || t('daysDialog|form|fields|friday|label'), field: interactor.form.fields.friday }),
                    react_1.default.createElement(components_1.CheckboxField, { label: (texts === null || texts === void 0 ? void 0 : texts.saturday) || t('daysDialog|form|fields|saturday|label'), field: interactor.form.fields.saturday }),
                    react_1.default.createElement(components_1.CheckboxField, { label: (texts === null || texts === void 0 ? void 0 : texts.sunday) || t('daysDialog|form|fields|sunday|label'), field: interactor.form.fields.sunday })) }))));
};
exports.DaysDialog = DaysDialog;
//# sourceMappingURL=DaysDialog.js.map